define('viewmodels/models/splash',[
    'underscore',
    'knockout'
], function (_, ko) {

    var Splash = function (
            splashPage,
            splashHook,
            dialog,
            ReelRacesHowItWorksDialog,
            navigation,
            splashPageShownCookieStorage,
            localStorageAccessorFactory) {

        var splashPageShownStorage = localStorageAccessorFactory.isLocalStorageEnabled ?
            localStorageAccessorFactory('splashPageShown') :
            splashPageShownCookieStorage;

        self.splashHook = splashHook;
        self.splashLogo = splashPage('logo');
        self.splashTagline = splashPage('tagline');
        self.splashLearnMoreText = splashPage('learn_more_text');
        self.splashBackgroundImage = splashPage('background_image');
        self.splashForegroundImage = splashPage('foreground_image');
        self.splashBackgroundImageForTablet = splashPage('background_image_for_tablet');
        self.splashForegroundImageForTablet = splashPage('foreground_image_for_tablet');
        self.splashSignupButtonLabel = splashPage('sign_up_button_label');
        self.splashSignupButtonColor = splashPage('signup_button_color');
        self.splashLoginButtonLabel = splashPage('login_button_label');
        self.splashLoginButtonColor = splashPage('login_button_color');
        self.welcomeBonusText = splashPage('welcome_bonus_text');
        self.splashPaymentProvidersImage = splashPage('payment_providers_image');

        self.isSplashOpen = ko.observable(true);

        self.closeSplashScreen = function () {
            self.isSplashOpen(false);
        };

        // Show the splash maximum 2 times
        if (splashPageShownStorage()) {
            splashPageShownStorage(splashPageShownStorage() + 1);
        } else {
            splashPageShownStorage(1);
        }

        navigation.getRouter().activeInstruction.subscribeAndExec(function (value) {
            var isStartPage = value.config.id === navigation.ROUTES.HOME;

            self.isSplashOpen(self.isSplashOpen() && isStartPage && splashPageShownStorage() <= 2);
        });

        self.compositionComplete = function () {

            if ($(window).height() < 500) {

                $('#splash .button').addClass('short');
            }
        };

        self.openReelRacesInfo = function () {
            var reelRacesDialog = new ReelRacesHowItWorksDialog({
                mode: 'summer-campaign',
                welcomeBonusText: self.welcomeBonusText()
            });

            dialog.showDialog(reelRacesDialog);
        };
    };

    return Splash;
});

